"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentRelationGroupImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing DocumentRelationGroup operations. */
var DocumentRelationGroupImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class DocumentRelationGroup class.
   * @param client Reference to the service client
   */
  function DocumentRelationGroupImpl(client) {
    (0, _classCallCheck2["default"])(this, DocumentRelationGroupImpl);
    this.client = client;
  }
  /**
   * Gets a list of bookmark ids that have any relations. (Auth: RhinestoneAuthorize[hiveId, fullName,
   * portalId])
   * @param portalId (Access Controlled)
   * @param hiveId (Access Controlled)
   * @param fullName (Access Controlled)
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(DocumentRelationGroupImpl, [{
    key: "getLocationsWithRelations",
    value: function getLocationsWithRelations(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getLocationsWithRelationsOperationSpec);
    }
    /**
     * Returns relation groups with all relations to/from a document, with and without bookmarks (Auth:
     * RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getDocumentRelationGroupsForAllV2",
    value: function getDocumentRelationGroupsForAllV2(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentRelationGroupsForAllV2OperationSpec);
    }
    /**
     * Returns relation groups with relations to/from a single bookmark in the document (which is a section
     * usually). (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getDocumentRelationGroupsForBookmarkV2",
    value: function getDocumentRelationGroupsForBookmarkV2(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentRelationGroupsForBookmarkV2OperationSpec);
    }
    /**
     * Returns relation groups with relations to/from the top of the document itself, i.e. relations with
     * blank bookmark (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getDocumentRelationGroupsForTopOfDocumentV2",
    value: function getDocumentRelationGroupsForTopOfDocumentV2(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentRelationGroupsForTopOfDocumentV2OperationSpec);
    }
  }]);
  return DocumentRelationGroupImpl;
}(); // Operation Specifications


exports.DocumentRelationGroupImpl = DocumentRelationGroupImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getLocationsWithRelationsOperationSpec = {
  path: "/api/Portals({portalId})/Document/LocationsWithRelations/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.DocumentRelationsLocationsModel
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getDocumentRelationGroupsForAllV2OperationSpec = {
  path: "/api/Portals({portalId})/Document/RelationGroupsAll/v2/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "RelationGroupDto"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getDocumentRelationGroupsForBookmarkV2OperationSpec = {
  path: "/api/Portals({portalId})/Document/RelationGroupsBookmark/v2/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "RelationGroupDto"
            }
          }
        }
      }
    },
    401: {},
    403: {},
    404: {}
  },
  queryParameters: [Parameters.bookmark],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getDocumentRelationGroupsForTopOfDocumentV2OperationSpec = {
  path: "/api/Portals({portalId})/Document/RelationGroupsDocument/v2/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "RelationGroupDto"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};